module.exports = __webpack_public_path__ + "r-v3/img/alert_blue.ae5a2853.svg";